import { render, staticRenderFns } from "./UserDetails.vue?vue&type=template&id=4bf1b9b7"
import script from "./UserDetails.vue?vue&type=script&lang=js"
export * from "./UserDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bf1b9b7')) {
      api.createRecord('4bf1b9b7', component.options)
    } else {
      api.reload('4bf1b9b7', component.options)
    }
    module.hot.accept("./UserDetails.vue?vue&type=template&id=4bf1b9b7", function () {
      api.rerender('4bf1b9b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/UserDetails.vue"
export default component.exports